import React, { FunctionComponent } from 'react';
import { Accordion, AccordionDetails, AccordionSummary, Grid, Typography } from '@material-ui/core';
import SurveillanceServiceDataModel from '../../../../data-models/SurveillanceService.DataModel';
import styles from '../referral-summary/ReferralSummary.Styles';

interface IReferralSurveillanceSummaryProps {
    surveillanceService: SurveillanceServiceDataModel;
}

export const ReferralSurveillanceSummary: FunctionComponent<IReferralSurveillanceSummaryProps> = (props) => {
    const classes = styles();
    const surveillance = props.surveillanceService;
    const caseDetails = surveillance?.caseDetails ?? {};

    const renderMultiline = (value?: string) =>
        value?.split('\n').map((line, index) => (
            <Typography key={`${line}-${index}`} variant="subtitle2" className={classes.blackFont}>
                {line}
            </Typography>
        ));

    return (
        <Accordion defaultExpanded className={classes.paper} square>
            <AccordionSummary aria-controls="surveillance-panel-content" id="surveillance-accordion" className={classes.paperHeader}>
                <Typography variant="subtitle2" className={classes.paperTitle}>
                    Surveillance
                </Typography>
            </AccordionSummary>
            <AccordionDetails>
                <Grid container spacing={3} className={classes.gridContainer}>
                    <Grid item xs={3}>
                        <Typography variant="body2" className={classes.dataLabel}>
                            Rush Request
                        </Typography>
                        <Typography variant="subtitle2" className={classes.blackFont}>
                            {caseDetails.rushRequest ? 'Yes' : 'No'}
                        </Typography>
                    </Grid>

                    {surveillance?.backgroundInvestigationOption != null && (
                        <Grid item xs={3}>
                            <Typography variant="body2" className={classes.dataLabel}>
                                Background Investigation Option
                            </Typography>
                            <Typography variant="subtitle2" className={classes.blackFont}>
                                {surveillance.backgroundInvestigationOption}
                            </Typography>
                        </Grid>
                    )}

                    {surveillance?.eRemoteUnmannedOption != null && (
                        <Grid item xs={3}>
                            <Typography variant="body2" className={classes.dataLabel}>
                                eRemote (Unmanned) Option
                            </Typography>
                            <Typography variant="subtitle2" className={classes.blackFont}>
                                {surveillance.eRemoteUnmannedOption}
                            </Typography>
                        </Grid>
                    )}

                    {(surveillance?.eRemoteUnmannedNumberOfDays != null ||
                        surveillance?.surveillanceMannedNumberOfDays != null) && (
                        <Grid item xs={3}>
                            <Typography variant="body2" className={classes.dataLabel}>
                                Number of Days
                            </Typography>
                            {surveillance?.eRemoteUnmannedNumberOfDays != null && (
                                <Typography variant="subtitle2" className={classes.blackFont}>
                                    eRemote (Unmanned): {surveillance.eRemoteUnmannedNumberOfDays}
                                </Typography>
                            )}
                            {surveillance?.surveillanceMannedNumberOfDays != null && (
                                <Typography variant="subtitle2" className={classes.blackFont}>
                                    Surveillance (Manned): {surveillance.surveillanceMannedNumberOfDays}
                                </Typography>
                            )}
                        </Grid>
                    )}

                    {surveillance?.facilityTypes && surveillance.facilityTypes.length > 0 && (
                        <Grid item xs={3}>
                            <Typography variant="body2" className={classes.dataLabel}>
                                Facility Types
                            </Typography>
                            <Typography variant="subtitle2" className={classes.blackFont}>
                                {surveillance.facilityTypes.map((ft) => ft.facilityTypeName).join(', ')}
                            </Typography>
                        </Grid>
                    )}

                    {surveillance?.medicalCanvassNumberOfFacilities != null && (
                        <Grid item xs={3}>
                            <Typography variant="body2" className={classes.dataLabel}>
                                Number of Facilities
                            </Typography>
                            <Typography variant="subtitle2" className={classes.blackFont}>
                                {surveillance.medicalCanvassNumberOfFacilities}
                            </Typography>
                        </Grid>
                    )}

                    {surveillance?.desktopInvestigationNumberOfHours != null && (
                        <Grid item xs={3}>
                            <Typography variant="body2" className={classes.dataLabel}>
                                Number of Hours
                            </Typography>
                            <Typography variant="subtitle2" className={classes.blackFont}>
                                Desktop Investigation: {surveillance.desktopInvestigationNumberOfHours}
                            </Typography>
                        </Grid>
                    )}

                    <Grid item xs={12}>
                        <Typography variant="body2" className={classes.dataLabel}>
                            Alleged Injury
                        </Typography>
                        {renderMultiline(caseDetails.allegedInjury)}
                    </Grid>

                    <Grid item xs={12}>
                        <Typography variant="body2" className={classes.dataLabel}>
                            Restrictions
                        </Typography>
                        {renderMultiline(caseDetails.restrictions)}
                    </Grid>

                    <Grid item xs={12}>
                        <Typography variant="body2" className={classes.dataLabel}>
                            Additional Comments
                        </Typography>
                        {renderMultiline(caseDetails.additionalInformation)}
                    </Grid>
                </Grid>
            </AccordionDetails>
        </Accordion>
    );
};
